import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import {styled, Typography} from "@mui/material";
import {removeCheckedRuleAndAllDependants} from "../features/validationRuleSlice";
import {useDispatch} from "react-redux";

const StyledDialog = styled(Dialog)({
    '& .MuiDialog-paper': {
        width: '600px',
        height: '300px'
    }
})

export default function ValidationRuleDialog(props) {
    const dialogInfo = props.dialogInfo;
    const checkbox = props.checkbox;
    const ruleName = props.ruleName;

    const dispatch = useDispatch();

    const handleClose = () => {
        props.setDialogOpen(false);
    };

    const handleConfirm = () => {
        // remove all dependants
        const selectedRulesName = [...dialogInfo, ruleName];
        dispatch(removeCheckedRuleAndAllDependants({'selectedRulesName': selectedRulesName}));
        props.setDialogOpen(false);
    }

    return (
        <div>
            <StyledDialog
                open={props.dialogOpen}
                onClose={handleClose}
            >
                <DialogTitle>
                    {checkbox ? "Missing Required Rules" : `There are other rules depend on "${ruleName}"`}
                </DialogTitle>
                <DialogContent dividers sx={{ position: 'relative'}}>
                    <DialogContentText sx={{ color: 'primary.dark'}}>
                        {dialogInfo && dialogInfo.map( (d, i) => {
                            return (<li key={i}>{d}</li>)
                        })}
                    </DialogContentText>
                    {!checkbox && <Typography sx={{ position: 'absolute', bottom: '8px', marginLeft: '23%', fontWeight: 'bold'}}>Do you want to uncheck all the rules ?</Typography>}
                </DialogContent>
                <DialogActions sx={{ display: 'flex', justifyContent: 'center'}}>
                    <Button onClick={handleClose} autoFocus variant='contained'>
                        Cancel
                    </Button>
                    {!checkbox && <Button variant='contained' onClick={handleConfirm}>Confirm</Button>}
                </DialogActions>
            </StyledDialog>
        </div>
    );
}
